import React, { useEffect } from 'react';

import { css } from '@emotion/css';
import { Typography } from 'antd';
import { theme } from 'theme';

export const ALLOW_KEYBOARD_SHORTCUTS_ID = 'allow-keyboard-shortcuts';

export type KeyboardShortcutProps = {
  shortcut: string;
  onClick: () => void;
};

export const KeyboardShortcut = ({ shortcut, onClick }: KeyboardShortcutProps) => {
  useEffect(() => {
    const normalizedShortcut = shortcut.toLowerCase();
    const ignoreTags = ['INPUT', 'TEXTAREA', 'SELECT', 'BUTTON'];

    const handleKeyDown = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement;
      if (
        (ignoreTags.includes(target.tagName) || target.isContentEditable) &&
        !target.classList.contains(ALLOW_KEYBOARD_SHORTCUTS_ID)
      ) {
        return;
      }

      if (event.key.toLowerCase() === normalizedShortcut) {
        onClick();
        event.preventDefault();
        event.stopPropagation();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [shortcut, onClick]);
  return (
    <div
      className={css`
        font-size: 10px;
        background-color: ${theme.colors.neutral[200]};
        padding-left: 5px;
        padding-right: 5px;
        border-radius: 4px;
        border: 1px solid ${theme.colors.neutral[400]};
      `}
    >
      <Typography.Text style={{ fontSize: 10, color: theme.colors.neutral[500] }}>{shortcut}</Typography.Text>
    </div>
  );
};
